'use client';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    // Immediately redirect to login page
    router.replace('/home/');
  }, [router]);

  // Return null to show nothing while redirecting
  return null;
}
